import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { useTranslation } from 'react-i18next'

export type ConfirmationDialogProps = {
  title: string
  onConfirm: () => void
  message?: string
  onCancel?: () => void
  confirmText?: string
  cancelText?: string
  open?: boolean
  onClose?: () => void
}

export const ConfirmationDialog = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  open,
  onClose,
  ...props
}: ConfirmationDialogProps) => {
  const { t } = useTranslation()

  confirmText = confirmText || t('common:ok')
  cancelText = cancelText || t('common:cancel')
  message =
    message ||
    t('common:irreversible-action', 'This action is not reversible. Continue?')

  const { closeDialog } = useDialogManager()

  const handleConfirm = () => {
    onClose()
    closeDialog(true)
    if (onConfirm) {
      onConfirm()
    }
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    }
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      maxWidth="sm"
      fullWidth
      {...props}
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="confirmation-dialog-description"
          style={{ whiteSpace: 'pre-line' }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          {cancelText}
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
